import React from 'react';
import { Button } from 'react-bootstrap';
import UserProfile from '../../assets/img/user_profile.svg';

const AddStaff = ({ onAddStaffClicked }) => (
  <div className="my-staff-card">
    <div className="user-profile-add">
      <img src={UserProfile} />
    </div>
    <div className="staff-add">
      <div className="staff-add-text">
        Add another member of staff
      </div>
      <div className="my-staff-button-container">
        <Button
          className="red-btn"
          onClick={() => onAddStaffClicked()}
        >
          Add
        </Button>
      </div>
    </div>
  </div>
);

export default AddStaff;



// WEBPACK FOOTER //
// ./src/components/my-staff/add-staff.jsx